import type { AchievementBackgroundProps } from '../Achievement';

export const QuestPlaceholder = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.0664 66.7158C32.9382 70.4413 39.0618 70.4413 42.9336 66.7158L58.2041 52.0225C59.5631 50.7148 60.5245 49.0486 60.9775 47.2178L66.0674 26.6465C67.3577 21.4308 64.296 16.128 59.1338 14.6377L38.7734 8.75977C36.9615 8.23671 35.0385 8.23671 33.2266 8.75977L12.8662 14.6377C7.70401 16.128 4.64227 21.4308 5.93262 26.6465L11.0225 47.2178C11.4755 49.0486 12.4369 50.7148 13.7959 52.0225L29.0664 66.7158Z"
      fill="#EAEAEC"
      stroke="#9FA3A7"
      strokeWidth="2"
    />
  </svg>
);
